(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var W = 0.86, H = 0.88;
    function fit(g) {
      if (g.__rp) return;
      var img = g.querySelector('slideshow-slide img');
      if (!img) return;
      var src = img.currentSrc || img.src;
      if (!src || !img.complete || !img.naturalWidth) {
        g.__rpw = g.__rpw || 0;
        if (g.__rpw++ < 40) setTimeout(function () { fit(g); }, 150);
        else g.setAttribute('data-rp-done', '1');
        return;
      }
      g.__rp = 1;
      var u = src.indexOf('width=') > -1 ? src.replace(/([?&])width=\d+/, '$1width=240') : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=240';
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight, c = document.createElement('canvas');
          c.width = w; c.height = h;
          var x = c.getContext('2d');
          x.drawImage(im, 0, 0);
          var d = x.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (var y = 0; y < h; y++) for (var i = 0; i < w; i++) {
            var p = (y * w + i) * 4;
            if (d[p] < 238 || d[p + 1] < 238 || d[p + 2] < 238) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; }
          }
          if (x1 > 0) {
            var ar = w / h, fw = Math.min(1, ar / 0.75), fh = Math.min(1, 0.75 / ar);
            var rw = (x1 - x0 + 1) / w * fw, rh = (y1 - y0 + 1) / h * fh;
            var ex = 0.5 + ((x0 + x1 + 1) / 2 / w - 0.5) * fw, ey = 0.5 + ((y0 + y1 + 1) / 2 / h - 0.5) * fh;
            var k = Math.min(W / rw, H / rh);
            if (k > 0.5 && k < 2.2) {
              img.style.transition = 'none';
              img.style.transform = 'translate(' + (-k * (ex - 0.5) * 100) + '%,' + (-k * (ey - 0.5) * 100) + '%) scale(' + k + ')';
            }
          }
        } catch (e) {}
        g.setAttribute('data-rp-done', '1');
      };
      im.onerror = function () { g.setAttribute('data-rp-done', '1'); };
      im.src = u;
    }
    function scan() {
      document.querySelectorAll('.card-gallery[data-rp-rug="true"]:not([data-rp-done])').forEach(fit);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
    new MutationObserver(function () { scan(); }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__rpFanCrop) return;
    window.__rpFanCrop = true;

    function crop(img) {
      if (img.dataset.rpCropped || !img.naturalWidth) return;
      try {
        var w = 60, h = 90;
        var c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, w, h);
        var d = x.getImageData(0, 0, w, h).data;
        var minX = w, minY = h, maxX = -1, maxY = -1;
        for (var j = 0; j < h; j++) {
          for (var i = 0; i < w; i++) {
            var k = (j * w + i) * 4;
            if (d[k + 3] < 10 || (d[k] > 243 && d[k + 1] > 243 && d[k + 2] > 243)) continue;
            if (i < minX) minX = i;
            if (i > maxX) maxX = i;
            if (j < minY) minY = j;
            if (j > maxY) maxY = j;
          }
        }
        if (maxX < 0) return;
        var bw = (maxX - minX + 1) / w + 0.04;
        var bh = (maxY - minY + 1) / h + 0.04;
        var rh = Math.max(bh, bw / 1.125);
        var rw = rh * 1.125;
        var cx = (minX + maxX + 1) / 2 / w;
        var cy = (minY + maxY + 1) / 2 / h;
        var l = rw >= 1 ? (1 - rw) / 2 : Math.min(Math.max(cx - rw / 2, 0), 1 - rw);
        var t = rh >= 1 ? (1 - rh) / 2 : Math.min(Math.max(cy - rh / 2, 0), 1 - rh);
        img.style.cssText =
          'position:absolute;max-width:none;object-fit:fill;width:' + 100 / rw + '%;height:' + 100 / rh +
          '%;left:' + (-l / rw) * 100 + '%;top:' + (-t / rh) * 100 + '%';
        img.dataset.rpCropped = '1';
      } catch (e) {}
    }

    document.addEventListener(
      'load',
      function (e) {
        var el = e.target;
        if (el && el.matches && el.matches('.rp-fan__item img')) crop(el);
      },
      true
    );

    function scan() {
      document.querySelectorAll('.rp-fan__item img').forEach(function (img) {
        if (img.complete) crop(img);
      });
    }

    scan();
    document.addEventListener('DOMContentLoaded', scan);
    window.addEventListener('load', scan);

    /* Telefon: bir ürüne basılı tutunca yelpaze açılır */
    var coarse = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
    if (coarse) {
      var timer = null;
      var opened = null;
      var openedAt = 0;

      function closeFan() {
        if (opened) {
          opened.classList.remove('rp-fan-open');
          opened = null;
        }
      }

      document.addEventListener(
        'touchstart',
        function (e) {
          var t = e.target;
          if (!t || !t.closest) return;
          if (t.closest('.rp-fan')) {
            clearTimeout(timer);
            return;
          }
          var card = t.closest('product-card');
          if (!card || !card.querySelector('.rp-fan')) {
            closeFan();
            return;
          }
          if (opened && opened !== card) closeFan();
          clearTimeout(timer);
          timer = setTimeout(function () {
            closeFan();
            card.classList.add('rp-fan-open');
            opened = card;
            openedAt = Date.now();
          }, 380);
        },
        { passive: true }
      );

      ['touchend', 'touchcancel', 'touchmove'].forEach(function (ev) {
        document.addEventListener(
          ev,
          function () {
            clearTimeout(timer);
          },
          { passive: true }
        );
      });

      document.addEventListener(
        'click',
        function (e) {
          var t = e.target;
          if (!t || !t.closest || t.closest('.rp-fan')) return;
          if (opened && Date.now() - openedAt < 1500) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      document.addEventListener('contextmenu', function (e) {
        if (e.target && e.target.closest && e.target.closest('product-card')) e.preventDefault();
      });

      window.addEventListener('scroll', closeFan, { passive: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
